import testCpf from '@niaratech/niara-js-commons/dist/test-cpf';
import type { FieldValidationHandler } from '../components/types';
const cpfValidator: FieldValidationHandler<string> = value => {
  if (value && !testCpf(value)) {
    return {
      errors: ["Número de Cpf inválido"]
    };
  }
};
export default cpfValidator;